<template>
  <div>
    <section class="section" v-if="!deletedProposals.length">
      <div class="content has-text-grey has-text-centered">
        <p>Nenhuma proposta excluída.</p>
      </div>
    </section>

    <b-table
      class="table is-fullwidth proposals-table"
      default-sort-direction="ASC"
      v-if="deletedProposals.length"
      :data="deletedProposals"
    >
      <b-table-column centered sortable field="deletedAt" label="Excluída em" v-slot="props">
        <div class="date-column">
          {{ (props.row.deletedAt || props.row.data) | formatDatetime }}
        </div>
      </b-table-column>

      <b-table-column centered label="Fornecedor" v-slot="props">
        {{
          displaySocialDenomination
            ? `(${props.row.fornecedor}) ${props.row.denominacaoSocial}`
            : props.row.fornecedor
        }}
      </b-table-column>

      <b-table-column centered label="Porte" v-slot="props">
        {{ formatCompanySize(props.row.fornecedor_porte) }}
      </b-table-column>

      <b-table-column v-if="!isLot" centered label="Marca" v-slot="props">
        {{ props.row.marca }}
      </b-table-column>

      <b-table-column v-if="!isLot" centered label="Importado" v-slot="props">
        {{ formatImported(props.row.fabricado) }}
      </b-table-column>

      <b-table-column centered label="Percentual" v-slot="props" :visible="highestDiscount">
        {{ `${formatPercentage(props.row.percentual || 0)}%` }}
      </b-table-column>

      <b-table-column
        centered
        label="Valor"
        v-slot="props"
        :visible="!highestDiscount || !!(highestDiscount && item.referencia && item.total)"
      >
        {{ props.row.valor ? formatValue(props.row.valor) : 0 }}
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  formatarDataSegundo as formatDatetime,
  formatarValor as formatValue,
  formatarPorcentagem as formatPercentage,
} from '@/utils/format';

export default {
  name: 'DeletedProposalsList',
  props: {
    displaySocialDenomination: { type: Boolean, default: false },
    highestDiscount: { type: Boolean, default: false },
    item: { type: Object, default: () => ({}) },
    formatCompanySize: { type: Function, default: () => v => v },
  },
  data() {
    return { formatPercentage, formatValue };
  },
  filters: { formatDatetime },
  computed: {
    ...mapGetters('proposals', ['obterPropostasDeletadasItem']),
    deletedProposals() {
      return this.obterPropostasDeletadasItem(this.item.id) || [];
    },
    isLot() {
      return this.item && this.item.item && this.item.item.tipo === 'LOT';
    },
  },
  methods: {
    formatImported(fabricado) {
      return { BRASIL: 'Não', IMPORTADO: 'Sim' }[fabricado];
    },
  },
};
</script>

<style lang="scss" scoped>
.date-column {
  min-width: fit-content;
}

@media (max-width: 1500px) {
  .proposals-table {
    font-size: 0.9rem;
  }
}

.truncate-span {
  display: block;
  max-height: 60px;
  overflow-y: auto;
  white-space: normal;
  word-wrap: break-word;
  padding: 5px;
  max-width: 450px;
}
</style>
